import { apiClient } from '../../../../lib/api-client';
import { FileAttachmentResult } from '../types/FileAttachmentResult';

export async function apiGetFileAttachment(fileName: string, awsS3Key: string): Promise<FileAttachmentResult> {
	try {
		return await apiClient.get("document/file",
			{
				params: { fileName, awsS3Key }
			});
	}
	catch (error: any) {
		return {
			isSuccess: false,
			errorMessage: error
		};
	}
};
